const typeInfoRegex = /^:([a-z])(\((.+)\))?/
import labels from '../labels/labels.json'
const I18n = {
	use(locale) {
		I18n.locale = locale
		I18n.messageBundle = labels[locale] || {}
		return I18n.translate
	},

	translate(strings, ...values) {
		const translationKey = I18n.buildKey(strings)

		const translationString = I18n.messageBundle[translationKey.toLowerCase()]

		if (translationString) {
			const typeInfoForValues = strings.slice(1).map(I18n.extractTypeInfo)
			const localizedValues = values.map((v, i) => I18n.localize(v, typeInfoForValues[i]))
			return I18n.buildMessage(translationString, ...localizedValues)
		}

		return strings.join(' ')
	},

	localizers: {
		s /* string */: v => v.toLocaleString(I18n.locale),
		c /* currency */: (v, currency) => v.toLocaleString(I18n.locale, {
			style: 'currency',
			currency: currency || I18n.defaultCurrency
		}),
		n /* number */: (v, fractionalDigits) => v.toLocaleString(I18n.locale, {
			minimumFractionDigits: fractionalDigits,
			maximumFractionDigits: fractionalDigits
		})
	},

	extractTypeInfo(str) {
		const match = typeInfoRegex.exec(str)
		if (match) {
			return { type: match[1], options: match[3] }
		}
		return { type: 's', options: '' }

	},

	localize(value, { type, options }) {
		const localized = I18n.localizers[type](value, options) || ''
		return I18n.messageBundle[localized.toLowerCase()] || localized
	},

	// e.g. I18n.buildKey(['', ' has ', ':c in the']) == '{0} has {1} in the bank'
	buildKey(strings) {
		const stripType = s => s.replace(typeInfoRegex, '')
		const lastPartialKey = stripType(strings[strings.length - 1])
		const prependPartialKey = (memo, curr, i) => `${ stripType(curr) }{${ i }}${ memo }`

		return strings.slice(0, -1).reduceRight(prependPartialKey, lastPartialKey)
	},

	// e.g. I18n.formatStrings('{0} {1}!', 'hello', 'world') == 'hello world!'
	buildMessage(str, ...values) {
		return str.replace(/{(\d)}/g, (_, index) => values[Number(index)])
	}
}

export default I18n



// WEBPACK FOOTER //
// ./src/client/utils/i18n.js